import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import SideCart from './SideCart';

class ProductInfo extends HTMLElement {
    sidecart = document.querySelector<SideCart>('side-cart');

    constructor() {
        super()
        this.init()
    }

    private init() : void {
        this.handleChangeVariant()
        this.handleStickyWhenScrolling()
    }

    updateURL(productInfo: HTMLElement | null) {
        const productUrl = this.dataset.url
        const variantId = productInfo?.dataset.selectedVariant

        window.history.replaceState({}, '', `${productUrl}${variantId ? `?variant=${variantId}` : ''}`);
    }

    private async getUpdatedSection() {
        const sectionId = this.dataset.section
        const productUrl = this.dataset.url
        const values = this.getSelectedValues()
        const destination = document.getElementById(`shopify-section-${sectionId}`)

        try {
            await fetch(`${productUrl}?section_id=${sectionId}&option_values=${values.toString()}`, {
                method: 'GET'
            })
            .then(response => response.text())
            .then(responseText => {
                if(destination) {
                    destination.innerHTML = responseText
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    this.updateURL( html.querySelector('product-info'))
                    this.updateBackInStockForm(html)
                }
            });
        } catch (error) {
            
        }
    }

    // handle every change on variant selects
    private handleChangeVariant() {
        const inputs = this.querySelectorAll('input.product__variant-input')

        inputs.forEach((input) => {
            input.addEventListener('change', async () =>{
                console.info('input has changed')
                await this.getUpdatedSection()
                this.initAccordions()
                this.initSliders()
                this.sidecart?.initializeAddEvent()
            })
        })
    }

    private verifyIsVisible (element: HTMLElement): boolean {
        const item = element.getBoundingClientRect()
        return (
            item.top >= 0 &&
            item.left >= 0 &&
            item.bottom <= (
                window.innerHeight ||
                document.documentElement.clientHeight) &&
            item.right <= (
                window.innerWidth ||
                document.documentElement.clientWidth)
        ) 
    }

    private toggleStickyATC (reference: HTMLElement, sticky: HTMLElement) {
        if (this.verifyIsVisible(reference)) {
            sticky.classList.remove('visible')
        } else {
            sticky.classList.add('visible')
        }
    }

    private handleStickyWhenScrolling = () => {
        const stickyATC = this.querySelector<HTMLElement>('.product-sticky-bar')
        const mainProductButtons = this.querySelector<HTMLElement>('.product__buy-buttons') || document.createElement('div')
    
        if(!stickyATC) { return }
    
        window.addEventListener('scroll', () => {
            this.toggleStickyATC(mainProductButtons, stickyATC);
        });
    }

    private getSelectedValues() {
        const inputsSelected = this.querySelectorAll('input.product__variant-input:checked')
        let values: (string | null)[] = []
        inputsSelected.forEach((input) => {
            values.push(input.getAttribute('data-option-value-id'))
        })
        return values
    }

    async closingAccordions (parent: any) {
        const accordionsToClose = parent.querySelectorAll(".accordion-js-item.is-open")
        accordionsToClose.forEach((item: any) => {
            item.classList.remove("is-open")
            item.querySelector(".accordion-js-toggle").classList.remove("is-open")
            item.querySelector(".accordion-js-content").classList.remove("is-open")
        })
    }
    
    initAccordions() {
        const accordionToggles = document.querySelectorAll(".accordion-js-toggle")
        if (!accordionToggles) { return }
    
        accordionToggles.forEach((accordionToggle) => {
            accordionToggle.addEventListener("click", async () => {
                const accordionContent = accordionToggle.parentElement?.querySelector('.accordion-js-content')
                const accordionItem = accordionToggle.parentElement
    
                await this.closingAccordions(accordionToggle.closest(".accordion-js"))
    
                if (accordionToggle.classList.contains("is-open")) {
                    accordionToggle.classList.remove("is-open")
                    accordionContent?.classList.remove("is-open")
                    accordionItem?.classList.remove("is-open")
                } else { 
                    accordionToggle.classList.add("is-open")
                    accordionContent?.classList.add("is-open")
                    accordionItem?.classList.add("is-open")
                }
            });
        });
    }

    initSliders() {
        const productGalleryThumbs = new Swiper(".product-gallery-thumbs", {
            slidesPerView: 5,
            direction: 'vertical',
            watchOverflow: true,
            watchSlidesProgress: true,
            spaceBetween: 8,
        });
    
        new Swiper(".product-gallery-main", {
            modules: [Navigation, Pagination, Thumbs],
            watchOverflow: true,
            // watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            pagination: {
              el: '.product-gallery-main-pagination',
              clickable: true
            },
            effect: 'fade',
              fadeEffect: {
              crossFade: true
            },
            thumbs: {
              swiper: productGalleryThumbs
            }
        });
    }

    private updateBackInStockForm(html: Document): void {
        const newBISForm = html.querySelector('.product__back-in-stock-form') as HTMLElement;
        const currentBISForm = this.querySelector('.product__back-in-stock-form') as HTMLElement;

        if (newBISForm && currentBISForm) {
            const variantId = newBISForm.dataset.variantId;
            const productId = newBISForm.dataset.productId;
            const productTitle = newBISForm.dataset.productTitle;
            const variantTitle = newBISForm.dataset.variantTitle;

            if (variantId && productId && productTitle && variantTitle) {
                const bisComponent = currentBISForm.querySelector('back-in-stock-form') as any;
                if (bisComponent && typeof bisComponent.updateVariant === 'function') {
                    bisComponent.updateVariant(variantId, productId, productTitle, variantTitle);
                }
            }
        }
    }
}

export default ProductInfo